var _radialGradient, _radialGradient2, _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRxjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 247,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 247",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "78.763611%",
    cy: "37.847639%",
    r: "89.872558%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f80090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d008e"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "68.738902%",
    cy: "4.398337%",
    r: "81.728479%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291746283,
    stopColor: "#5c008e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f80090"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "18.238653%",
    x2: "81.159113%",
    y1: "0%",
    y2: "84.337476%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f70090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669712865,
    stopColor: "#e50090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827147533,
    stopColor: "#d6008f",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c10090",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "64.906059%",
    x2: "44.28977%",
    y1: "71.558554%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2008f",
    stopOpacity: 0.15134
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.400350765,
    stopColor: "#f70090",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648995536,
    stopColor: "#f60090",
    stopOpacity: 0.891668
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0090"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.6852208 157.125328c-13.11831378-69.7454956 21.5510817-137.0108202 101.1234852-145.9591081-10.97309-11.72502163-25.9634973-11.81312553-32.8605363-10.38683981-12.1778817 3.88106363-11.7955765 11.76147491-25.6091545 21.94058741-13.7325715 7.8434632-20.6295996 1.8368507-30.6332697 9.967984-9.9822606 8.0704359-3.0168927 26.5972217-7.2034632 30.1991342-4.1558442 7.2034632-17.04727278 13.6206407-19.39393944 22.7191688-1.93939394 11.6358096 5.26406926 19.9474975 4.98701298 29.9215235.83116884 8.311689-8.27456277 13.011671-6.96630303 19.748018 3.91868399 11.005229 11.47179219 17.629091 15.03251949 20.682251.8165362.575484 1.6789158 1.992783 1.5236485 1.167281z",
    fill: "#ff0090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m158.275491 60.578542c-2.907005 0-5.264069-2.3570644-5.264069-5.2640693 0-2.9070048 2.357064-5.2640692 5.264069-5.2640692s5.264069 2.3570644 5.264069 5.2640692c0 2.9070049-2.357064 5.2640693-5.264069 5.2640693zm-138.5188505 104.154266c-12.6066147-60.616035 26.403595-111.2651924 101.9474215-86.3301275 44.327342 25.9319135 100.08922 24.2434215 102.60336 7.4805195 6.206639-20.0953231-28.259741-61.5064935-79.792208-72.3116883-102.2337664-19.94805196-157.3488083 90.5452623-124.7585735 151.1612963z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m187.458604 171.493257c15.180468 1.644606 29.590165-1.998684 42.943723-12.883117-20.17413 22.502511-45.39955 33.816381-74.343065 36.895031 13.819567 11.748848 27.146528 17.041177 39.896104 14.775965-35.426632 9.775654-65.107419-.984607-101.2129387-36.940463-1.8906926 9.679349 8.3323137 24.759994 18.8693177 34.386591-61.1374541-26.505419-66.4973823-109.0728084 8.053565-129.3830403-77.2808685-37.1295827-120.9789365 35.0134693-99.5094656 94.1417073 21.0064924 45.540762 76.9844223 80.599292 138.3363186 72.889369 29.800765-3.6502 74.301847-24.196365 92.481501-72.889369-12.812745 11.497835-35.715723 21.511905-45.936047 22.280053 34.591031-17.287203 53.263969-46.662088 48.022719-86.810597-7.16523 17.058355-16.618944 30.159238-28.44426 39.156918 25.119577-39.156918 20.809143-59.395879 2.21645-81.6390652 13.298702 36.5714282-3.904277 77.1607272-41.373922 106.0200172z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m169.707072 213.625541c-2.624665-.490411 5.949857 3.473301-10.627706-.915225-16.577562-4.388526-33.456864-8.617572-64.3369387-39.369643-1.8906926 9.679349 8.3323137 24.759994 18.8693177 34.386591 28.44453 19.837663 9.100121 10.559533 52.440201 25.542217 3.477814-6.922619 3.655126-13.074135 3.655126-19.64394z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m114.601372 57.8510108s3.76808-5.561648 5.234847-8.0699857c1.797422-3.0737932 4.55772-8.6764071 4.55772-8.6764071s-29.004328-9.4628431-36.1222942-10.6174515c-22.1266233 5.7437136-22.2071426 15.0137894-9.8365798 29.2029495 1.3764156 1.5792208 36.166307-1.8391052 36.166307-1.8391052z",
    fill: "url(#d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxjs);
export default __webpack_public_path__ + "static/media/rxjs.1f39fca0cdaf0a523b7757d6b73d39ec.svg";
export { ForwardRef as ReactComponent };